import { toast } from '@/components/toast';
import { createKnowledge } from '@/services/api';
import { logger } from '@/services/logger';
import { IKnowledge, KnowledgeType } from '@d-id/types';
import { AxiosError } from 'axios';
import { MutationFunction, useMutation } from 'react-query';

const RETRIES = 3;

export function useCreateKnowledge() {
    const createKnowledgeMut: MutationFunction<{ id: string }, { agentName: string }> = async ({ agentName }) => {
        const knowledge: IKnowledge = {
            vector_store: 'https://pinecone...',
            name: `${agentName} knowledge`,
            description: `${agentName} knowledge description`,
            type: KnowledgeType.Knowledge,
        };

        const knowledgeResponse = await createKnowledge(knowledge);

        return knowledgeResponse;
    };

    return useMutation('create-knowledge', createKnowledgeMut, {
        retry(failureCount, error: AxiosError) {
            return (
                failureCount < RETRIES &&
                !!error.response?.status &&
                ([401, 403].some(status => error.response!.status === status) || error.response.status >= 500)
            );
        },
        onError: async (error: any) => {
            logger.error('Could not create knowledge', { error });
            toast.error({ title: `Could not create knowledge`, toastId: `knowledge-create-error` });
        },
    });
}
